type HighlightedTextNewsArticleType = {
  value: string;
};

export function HighlightedTextNewsArticle(props: HighlightedTextNewsArticleType) {
  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: props.value }} className="highlightedText" />
    </>
  );
}

export default HighlightedTextNewsArticle;
